<template>
  <a-modal :title="$t('participants.title')" @close="hide">
    <div class="connection">
      <div class="connection__header">
        <p>{{ $t(`alert.dataUsage`) }}:</p>
        <p>{{ user.consumptionData }} {{ user.unitData }}</p>
      </div>
      <div class="connection__content">
      <a-connection-status></a-connection-status>
      </div>
    </div>

    <template #footer>
      <a-button @click="hide"> {{ $t('dialog.button.cancel') }} </a-button>
    </template>
  </a-modal>
</template>

<script setup>
import {useAppStore, useUserStore} from '@/stores'
import AConnectionStatus from '@/components/AConnectionStatus.vue'
const app = useAppStore()
const user = useUserStore()

const hide = () => {
  app.transition('HIDE_SLOW_NETWORK_MODAL')
}
</script>

<style lang="scss">
.connection {
  position: relative;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    padding-bottom: $box-spacer;
    z-index: 1;
    .btn {
      position: relative;
      top: 0;
      right: 0;
    }
  }
}
</style>
